import { KnowledgeUiContext } from '../model/types';

const MAX_ACTIONS = 30;
const SAFE_KEY = /^[a-z0-9][a-z0-9._-]{0,99}$/;

const isVisible = (element: HTMLElement): boolean => {
    const style = window.getComputedStyle(element);

    return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        element.getClientRects().length > 0
    );
};

export const collectUiContext = (): KnowledgeUiContext | null => {
    const page = document.querySelector<HTMLElement>('[data-ai-page]');
    const pageKey = page?.dataset.aiPage;
    if (!pageKey || !SAFE_KEY.test(pageKey)) return null;

    const keys = new Set<string>();
    const actions = Array.from(document.querySelectorAll<HTMLElement>('[data-ai-action]'))
        .filter(isVisible)
        .flatMap((element) => {
            const key = element.dataset.aiAction;
            if (!key || !SAFE_KEY.test(key) || keys.has(key)) return [];
            keys.add(key);

            return [
                {
                    key,
                    disabled:
                        element.matches(':disabled') ||
                        element.getAttribute('aria-disabled') === 'true',
                },
            ];
        })
        .slice(0, MAX_ACTIONS);

    // Название поля определено backend API.
    // eslint-disable-next-line camelcase
    return { page_key: pageKey, actions };
};
